import { createContext } from 'react'

export const FormulaBarContext = createContext({
	variables: {},
	getFormulaFunction: null,
	saveFormula: null
})
